import reportData from './reports.json';

// Find first report of "Advance Metering Report"
const defaultReport = (() => {
  const targetDashboard = reportData.find(d => d.dashboard === "Advance Metering Report");
  const firstPage = targetDashboard?.pages?.[0];

  return {
    groupId: firstPage?.groupId || "",
    reportId: firstPage?.reportId || "",
    sectionId: firstPage?.sectionId || ""
  };
})();

export default defaultReport;
